import {
  useEffects
} from '../hook';

export default function Lifecycle(): null {
  useEffects();
  
  return null;
}
